import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';
import { md, lg, xl, wide, xwide } from '../common';

export function initReviewsSlider() {
  const parent = document.querySelector('.reviews-slider');
  if (!parent) return;

  const nextEl = parent.querySelector('.swiper-button-next');
  const prevEl = parent.querySelector('.swiper-button-prev');

  new Swiper('.reviews-slider__swiper', {
    modules: [Pagination, Navigation],
    slidesPerView: 'auto',
    loop: true,
    spaceBetween: 24,
    navigation: {
      prevEl: prevEl,
      nextEl: nextEl,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      [md]: { slidesPerView: 2, spaceBetween: 20, pagination: false },
      [lg]: { slidesPerView: 3, spaceBetween: 20, pagination: false },
      [wide]: { slidesPerView: 3, spaceBetween: 24, pagination: false },
      [xwide]: { slidesPerView: 3, spaceBetween: 32, pagination: false },
    },
  });
}
